import { toast } from 'vue3-toastify'
import api from '@/core/api'
import { handleError } from '@/helpers/handleError'
import type { ApiResponse, ApiErrorResponse } from '@/types/apiResponse'
import { toastDone } from '../util/toastHelper'

export async function createOrder(payload: any): Promise<ApiResponse> {
  try {
    const toastId = toast.loading('جاري انشاء الطلب')
    const { data } = await api.post(`/wp-json/wc/v3/orders`, payload)
    toastDone(toastId, 'تم انشاء الطلب بنجاح')
    return {
      success: true,
      data
    }
  } catch (error: any) {
    handleError(error)
    return {
      success: false,
      error: error as ApiErrorResponse
    }
  }
}
